import { Button } from "@chakra-ui/button";
import { Flex } from "@chakra-ui/layout";
import { useForm } from "react-hook-form";
import { FaTrash } from "react-icons/fa";
import PrimaryButton from "../Button/PrimaryButton";
import useFilters from "./hooks";
import { ModalStyled } from "./styles";

function Filters({
  children,
  width,
}: {
  children: (form: any) => JSX.Element;
  width?: number;
}) {
  const { isOpen, close, reset, filters, filter } = useFilters();

  const rest = useForm({
    defaultValues: filters,
  });

  if (!isOpen) {
    return null;
  }

  return (
    <ModalStyled
      visible={isOpen}
      title="Filtrar"
      width={width}
      footer={
        <Flex gridGap="16px" justifyContent="flex-end">
          <Button
            onClick={() => {
              rest.reset({});
              reset();
            }}
            variant="outline"
            leftIcon={<FaTrash fontSize="10px" />}
            size="sm"
          >
            Limpar
          </Button>
          <Button onClick={close} size="sm">
            Cancelar
          </Button>
          <PrimaryButton onClick={() => rest.handleSubmit(filter)()} size="sm">
            Filtrar
          </PrimaryButton>
        </Flex>
      }
      onOk={close}
      onCancel={close}
    >
      {isOpen ? children(rest) : null}
    </ModalStyled>
  );
}

export default Filters;
